//import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState, useCallback } from "react";
import { View, StyleSheet, Image, FlatList, Alert, TouchableOpacity, Text } from 'react-native';
import configurationPost from "../config/configurationPost";
//import consoleLog from "../utility/consoleLog";
import connectionConfig from "../config/settings";
//import { ScrollView } from "react-native-gesture-handler";
import { useFocusEffect } from '@react-navigation/native';
import { Video } from 'expo-av';


//import PickerItem from "./PickerItem";
//import settingStorage from "../config/settingStorage";
// import {navigation} from "@react-navigation/native";
//import navigation from "../navigation/rootNavigation";
import routes from "../navigation/routes";
import ActivityIndicator from "./ActivityIndicator";
import { Foundation } from "@expo/vector-icons";
import colors from "../config/colors";
//import { set } from "react-native-reanimated";

var webUrl = connectionConfig.imageUrl + '/seedImages/'
var pointer = 0
var blockSize = 30
var pageNumber = 0
var arrayPublications = []
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'



function MosaicOfPublications(props) {
  const [publicationSucces, setPublicationSucces] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const video = React.useRef(null);
  const [status, setStatus] = useState({});

  const [oldOffset, setOldOffset] = useState(0);
  var foundUserChecker = props.foundUserChecker;

  // useEffect(() => {
  //  // debugger
  //     props.navigation.addListener('focus', () => {
  //        getPublications()
  //       })
  //     getPublications();

  //  }, []);

  useFocusEffect(
    useCallback(() => {
      pageNumber = 0
      arrayPublications = []
      getPublications();
      console.log('props.foundUserChecker ->', props.foundUserChecker)
    }, [props.userId])
  );

  const getPublications = async () => {
    //debugger
    pointer = pageNumber * blockSize
    setLoading(true)
    var post_values = {
      userId: props.userId,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/selectPubications/', configurationPost)
      .then(response => response.json())
      .then(response => {
        if (response.data.length === 0) {
          if (pageNumber > 0) {
            setLoading(false)
          } else {
            setPublicationSucces(false)
            setLoading(false)
          }
        } else {
          pageNumber++
          if (arrayPublications.length > 0) {
            arrayPublications = [...arrayPublications, ...response.data]
          } else {
            arrayPublications = response.data
          }
          setItems(arrayPublications)
          setLoading(false)
          setPublicationSucces(true)
        }
      })
      .catch(err => {
        console.log('getPublications failed :( review internet service)', err)
      })
  }



  return (
    <>

      <ActivityIndicator visible={loading} />

      {publicationSucces ?

        <FlatList
          style={styles.imageContainer}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          numColumns={3}
          initialNumToRender={items.length}

          onEndReachedThreshold={.5}
          onEndReached={() => getPublications()}
          renderItem={({ item, index }) => (
            <TouchableOpacity onPress={() => {
              var userId = props.userId
              props.navigation.navigate(routes.LISTINGS_SEEDS, {
                items,
                index,
                pointer,
                blockSize,
                pageNumber,
                foundUserChecker,
                userId
              })

            }}  >
              {item.seedPhoto.includes('.mp4') ?
                <Video
                  ref={video}
                  style={styles.image}
                  source={{
                    uri: seedVideoUri + item.seedPhoto
                  }}

                  resizeMode="contain"

                />
                :
                item.seedPhoto.includes('.mov') ?
                  <Video
                    ref={video}
                    style={styles.image}
                    source={{
                      uri: seedVideoUri + item.seedPhoto
                    }}

                    resizeMode="contain"

                  />
                  :
                  item.seedPhoto === '' ?
                    <Foundation //style={styles.image}
                      style={styles.image}
                      name="mountains"
                      size={120}
                      color={colors.medium} />
                    :
                    <Image
                      style={styles.image}
                      source={{ uri: webUrl + item.seedPhoto }}
                    />
              }
            </TouchableOpacity>
          )}
        />
        :
        <Text>This user has not publications yet.  :) </Text>
      }
    </>
  );
}

const styles = StyleSheet.create({
  imageContainer: {

    marginVertical: '2%',
    marginLeft: '2%',
    alignContent: 'center',
    width: '100%',
    // height:'100%',
    //justifyContent: 'space-evenly',
  },
  container: {
    height: '69%',
    width: '100%',
  },
  image: {
    margin: '2%',
    width: 120,
    height: 120
  },
})

export default MosaicOfPublications;